<template>
  <svg
    :width="size"
    :height="size"
    :viewBox="`0 0 ${size} ${size}`"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.78673 8.1248H2.125C1.84886 8.1248 1.625 8.34866 1.625 8.6248V17.3748C1.625 17.6509 1.84886 17.8748 2.125 17.8748H6.78673L12.88 22.1909C13.2112 22.4255 13.669 22.1887 13.669 21.7829V4.2167C13.669 3.81091 13.2112 3.57414 12.88 3.80869L6.78673 8.1248ZM22.1052 6.50138C21.8064 6.13151 21.2554 6.13339 20.925 6.47529C20.6101 6.80111 20.6138 7.31546 20.8956 7.67032C22.052 9.1265 22.749 10.9947 22.749 12.9999C22.749 15.0064 22.0521 16.8745 20.896 18.3295C20.6141 18.6844 20.6102 19.1988 20.9251 19.5247C21.2555 19.8665 21.8063 19.8684 22.1051 19.4986C23.5359 17.7276 24.375 15.4365 24.375 12.9999C24.375 10.5634 23.536 8.27241 22.1052 6.50138ZM16.9442 10.3732C17.3274 10.038 17.9204 10.1009 18.1701 10.5446C18.6677 11.4286 19.0219 12.477 19.0219 13.6499C19.0219 14.823 18.6676 15.8716 18.1698 16.7557C17.9202 17.199 17.3276 17.2619 16.9446 16.9269C16.6057 16.6305 16.5579 16.1277 16.7751 15.7332C17.1263 15.0952 17.3428 14.4008 17.3428 13.6499C17.3428 12.8989 17.1253 12.2044 16.7743 11.5663C16.5572 11.1719 16.6054 10.6695 16.9442 10.3732Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "i-volume",
  props: {
    size: {
      type: String | Number,
      default: "26"
    },
    color: {
      type: String,
      default: "white"
    }
  }
};
</script>

<style scoped lang="less">
svg {
  transition: all 0.5s;
  path {
    transition: all 0.5s;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/icons/play_control/volume.vue